import React from "react";
import { Navigate } from "react-router-dom";
import { getStoredUser } from "../utils/authStorage";

const RoleProtectedRoute = ({ children, allowedRoles }) => {
  const userData = getStoredUser();

  if (!userData) {
    return <Navigate to="/admin/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(userData.role)) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
};

export default RoleProtectedRoute;
